"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateLocalityAssign = void 0;
const client_1 = require("@apollo/client");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const localityAssignMutation = (0, client_1.gql) `
  mutation LocalityAssign($workspaceId: ID!, $localityId: ID!, $userId: ID!) {
  localityAssign(workspace: $workspaceId, locality: $localityId, user: $userId) {
    id
  }
}`;
const mutateLocalityAssign = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(localityAssignMutation, { variables });
    (0, error_handler_1.processErrors)(errors);
    return data?.localityAssign;
};
exports.mutateLocalityAssign = mutateLocalityAssign;
